import React from 'react';
import skeletonStyles from '@/components/HomePageSkeleton/index.module.scss';

/** 首页大 Banner 加载占位，复用 HomePageSkeleton 的 bannerBone，保证流光动画与下方骨架一致 */
const BigBannerShell: React.FC = () => (
  <div className={skeletonStyles.bannerBone} aria-busy="true" aria-label="Banner loading" />
);

export default BigBannerShell;
